import { ApplicationConfig, importProvidersFrom, LOCALE_ID } from '@angular/core'
import { provideRouter } from '@angular/router'
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { appRoutes } from './app.routes'
import { provideAnimations } from '@angular/platform-browser/animations'
import { HammerModule } from '@angular/platform-browser'
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core'
import { TranslateFirebaseLoader } from './core/firestore-services/translate-firebase-loader'
import { initializeApp, provideFirebaseApp } from '@angular/fire/app'
import { environment } from '../environments/environment'
import { getAuth, provideAuth } from '@angular/fire/auth'
import { getFirestore, provideFirestore } from '@angular/fire/firestore'
import { getFunctions, provideFunctions } from '@angular/fire/functions'
import { getStorage, provideStorage, Storage } from '@angular/fire/storage'
import { provideFmxErrors } from './shared/modules/form/errors/provide-fmx-errors'
import { provideNgcCookieConsent } from 'ngx-cookieconsent'
import { HttpRequestInterceptor } from './core/http-request-interceptor'
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog'
import { PixelModule } from '@bloomscorp/ngx-pixel'
import { registerLocaleData } from '@angular/common'
import localeRo from '@angular/common/locales/ro'
// todo: Safe to remove after the old configurator is not needed anymore
import 'hammerjs'
import { provideNativeDateAdapter } from '@angular/material/core'
import { FIREBASE_FUNCTIONS_REGION } from '../../commons/firebase.utils'

function translateFactory(storage: Storage, http: HttpClient): TranslateLoader {
	return new TranslateFirebaseLoader(storage, http, '/i18n')
}

registerLocaleData(localeRo)

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter(appRoutes),
		provideAnimations(),
		{ provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
		provideHttpClient(withInterceptorsFromDi()),
		// firebase
		provideFirebaseApp(() => initializeApp(environment.firebase)),
		provideAuth(() => getAuth()),
		provideFirestore(() => getFirestore()),
		provideFunctions(() => getFunctions(undefined, FIREBASE_FUNCTIONS_REGION)),
		provideStorage(() => getStorage()),
		// locale and translate
		{ provide: LOCALE_ID, useValue: 'ro' },
		provideTranslateService({
			loader: {
				provide: TranslateLoader,
				useFactory: translateFactory,
				deps: [Storage, HttpClient],
			},
		}),
		provideFmxErrors(),
		provideNgcCookieConsent({ cookie: { domain: '' }, enabled: false }),
		importProvidersFrom([PixelModule.forRoot({ pixelId: '443279677800571' })]),
		// angular material
		provideNativeDateAdapter(),
		{ provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { maxWidth: '80vw', maxHeight: '80vh' } },

		// todo: Safe to remove after the old configurator is not needed anymore
		importProvidersFrom([HammerModule]),
	],
}
